import { Modal } from "@/shared/components/ui/Modal";

export interface Reactor {
  name: string;
  company?: string;
}

interface ReactorsModalProps {
  isOpen: boolean;
  onClose: () => void;
  emoji: string;
  reactors: Reactor[];
}

export const ReactorsModal = ({
  isOpen,
  onClose,
  emoji,
  reactors,
}: ReactorsModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`${emoji}  (${reactors.length})`}
      size="lg"
    >
      {reactors.length === 0 ? (
        <p className="text-sm text-gray-400 italic text-center py-6">No reactions yet.</p>
      ) : (
        <div className="overflow-x-auto -mx-4 px-4">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs text-gray-500 border-b border-gray-200">
                <th className="pb-2 font-medium">Name</th>
                <th className="pb-2 font-medium">Company</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {reactors.map((r, i) => (
                <tr key={i} className="text-gray-700">
                  <td className="py-2 pr-3">{r.name}</td>
                  <td className="py-2 text-gray-500 whitespace-nowrap">{r.company || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Modal>
  );
};
